import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';

@Injectable()
export class BusinessConstitutionPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    return {
      type: 'mat-select',
      props: {
        label: 'Business Constitution (if any)',
        placeholder: 'Please Select',
        options: this.dataSetupFacade.dataSetup$?.pipe(map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.businessConstitution))),
      },
    };
  }
}

export function registerBusinessConstitutionPreset(): ConfigOption {
  return { presets: [{ name: 'businessConstitution', config: new BusinessConstitutionPresetProvider() }] };
}
